<template>
  <router-link
    v-bind="$props"
    class="inline-block py-[8px] px-[15px] bg-orange-500 text-white rounded-md shadow-sm hover:bg-orange-600 hover:shadow scale-100 hover:scale-105 transition duration-300"
    ><slot
  /></router-link>
</template>

<script>
export default {
  name: "RouterLinkButton",
};
</script>
